import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Comp({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('smarthomepanel');

    return (
        <div className={`${css.gsapBText1} gsapBText1`}>
            <div className="msg-title">{t('smart_home_panel.ten_title')}</div>
            <div className="msg-line1">{t('smart_home_panel.ten_subtitle')}</div>
            <div className="msg-line2">
                {t('smart_home_panel.ten_des_pc1')} <div></div>
                {t('smart_home_panel.ten_des_pc2')}
            </div>
        </div>
    );
}
